export class ContestSummaryModel {
    public id: number;
    public ccbTitle: string;
    public ccbDescription: string;
    public cctName: string;
    public cctDescription: string;
    public cctAcceptableFileFormats: string;
    public cctMinimumWidth: number;
    public cctMaximumWidth: number;
    public cctMinimumHeight: number;
    public cctMaximumHeight: number;
    public cctRecommendedResolution: number;
    public hasTermAndConditions: boolean;
    public termAndConditions: string;
}



// WEBPACK FOOTER //
// ./src/models/contest/contest.summary.model.ts